"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icon_info",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    opacity: "0.2",
    cx: "12",
    cy: "12",
    r: "12",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V11Z",
    fill: "#2F61E0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8Z",
    fill: "#2F61E0"
  }));
}

Svg.propTypes = {
  /** Margins */
  margin: _propTypes.default.string
};
Svg.defaultProps = {
  margin: '0'
};
var _default = Svg;
exports.default = _default;